import React, { Suspense, useState } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { localStorage } from 'dibs-browser-storage';

import { showSuspectedTradeUserAcquisition } from './helpers';
import { TRADE_STATUSES } from './../../../constants/userConstants';
import { TRADE_WINDFALL_REFERRAL_KEY } from './constants';

const SuspectedTradeUser = React.lazy(() =>
    import(/* webpackChunkName: "SuspectedTradeUser" */ './SuspectedTradeUser')
);

function SuspectedTradeUserLoaderComponent({ relay, user, viewer }) {
    const [continueShowing, setContinueShowing] = useState(false);

    const tradeStatus = get(user, 'verifiedTradeStatus');
    const serviceId = get(user, 'serviceId');

    //only have the windfall flag supersede trade status if user has none
    const hasWindfallFlag = localStorage.getItem(TRADE_WINDFALL_REFERRAL_KEY) && !tradeStatus;
    const shouldShowSuspectedTrade =
        showSuspectedTradeUserAcquisition() &&
        (tradeStatus === TRADE_STATUSES.SUSPECTED || continueShowing || hasWindfallFlag);

    //if the suspected trade palcement is shown this session, keep showing it regardless of prop changes
    if (shouldShowSuspectedTrade && !continueShowing) {
        setContinueShowing(true);
    }

    if (!shouldShowSuspectedTrade) {
        return null;
    }

    return (
        <Suspense fallback="">
            <SuspectedTradeUser
                relay={relay}
                viewer={viewer}
                user={user}
                serviceId={serviceId}
                onDismissAqcuisition={() => {
                    setContinueShowing(true);
                }}
            />
        </Suspense>
    );
}

SuspectedTradeUserLoaderComponent.propTypes = {
    relay: PropTypes.object,
    viewer: PropTypes.object,
    user: PropTypes.object,
};

export const SuspectedTradeUserLoader = createFragmentContainer(SuspectedTradeUserLoaderComponent, {
    viewer: graphql`
        fragment SuspectedTradeUserLoader_viewer on Viewer {
            ...SuspectedTradeUser_viewer
        }
    `,
    user: graphql`
        fragment SuspectedTradeUserLoader_user on User {
            verifiedTradeStatus
            serviceId
        }
    `,
});
